import React from 'react';
import Header from './app/Header';
import Footer from './app/Footer';
import FooterCopyright from './app/FooterCopyright';

// =================================================================
// AVISO INTERNO: modelo de Política de Privacidade compatível
// com a LGPD (Lei nº 13.709/2018) para a Fretz / Buzaym Marketing
// Digital LTDA. Recomenda-se revisão por advogado especializado
// em direito digital antes da publicação definitiva.
// =================================================================

const P = ({ children }) => (
  <p className="text-ink-700 leading-relaxed mt-3">{children}</p>
);
const Li = ({ children }) => (
  <li className="text-ink-700 leading-relaxed">{children}</li>
);

const sections = [
  {
    id: 'controlador',
    title: '1. Controlador dos dados',
    render: () => (
      <>
        <P>O controlador, nos termos do art. 5º, VI, da LGPD, é a <strong>BUZAYM MARKETING DIGITAL LTDA</strong> (FRETZ), pessoa jurídica de direito privado, inscrita no CNPJ sob o nº 49.130.988/0001-00, com sede em Goiânia/GO.</P>
      </>
    ),
  },
  {
    id: 'dpo',
    title: '2. Encarregado pelo Tratamento de Dados (DPO)',
    render: () => (
      <>
        <P>Para o exercício de qualquer direito ou esclarecimento sobre esta Política, o titular pode contatar nosso Encarregado:</P>
        <P><strong>privacidade@fretz.com.br</strong></P>
      </>
    ),
  },
  {
    id: 'dados',
    title: '3. Dados pessoais que tratamos',
    render: () => (
      <>
        <P>Tratamos as seguintes categorias de dados:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li><strong>Dados cadastrais</strong>: nome, e-mail, WhatsApp/telefone, dados da empresa contratante e — para motoristas de rota — CPF, data de nascimento, CNH, dados do veículo, selfie de validação.</Li>
          <Li><strong>Dados de uso</strong>: histórico de interesse comercial (formulário Fretz Empresas), PEDIDOS vinculados ao plano, comunicações, dispositivos utilizados, identificadores técnicos (cookies, ID de sessão).</Li>
          <Li><strong>Dados de localização</strong>: endereços de coleta e entrega informados; localização em tempo real do motorista de rota, quando autorizado pelo aplicativo, durante a rota ativa.</Li>
          <Li><strong>Dados financeiros</strong>: identificadores de transação fornecidos pelo provedor de pagamento — não armazenamos dados completos de cartão.</Li>
          <Li><strong>Dados de comunicação</strong>: registros de mensagens trocadas pelos canais oficiais (e-mail, formulário de suporte).</Li>
        </ol>
      </>
    ),
  },
  {
    id: 'bases',
    title: '4. Bases legais e finalidades',
    render: () => (
      <>
        <P>O tratamento é realizado nas seguintes hipóteses (art. 7º da LGPD):</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li><strong>Execução de contrato</strong> (art. 7º, V): para processar a contratação dos planos Fretz Empresas, operar as rotas, emitir comprovantes e atender o CLIENTE.</Li>
          <Li><strong>Cumprimento de obrigação legal ou regulatória</strong> (art. 7º, II): retenção de informações fiscais, atendimento a requisições do Poder Judiciário, da ANPD e de outras autoridades.</Li>
          <Li><strong>Legítimo interesse</strong> (art. 7º, IX): prevenção a fraude, segurança da PLATAFORMA, melhoria do serviço, estatísticas agregadas, comunicações operacionais essenciais.</Li>
          <Li><strong>Consentimento</strong> (art. 7º, I): cookies não essenciais, geolocalização precisa, comunicações de marketing. O consentimento pode ser revogado a qualquer tempo.</Li>
          <Li><strong>Proteção do crédito</strong> (art. 7º, X): análise de inadimplência ou fraude.</Li>
          <Li><strong>Exercício regular de direitos</strong> (art. 7º, VI): em processos judiciais, administrativos ou arbitrais.</Li>
        </ol>
      </>
    ),
  },
  {
    id: 'compartilhamento',
    title: '5. Compartilhamento e operadores',
    render: () => (
      <>
        <P>Compartilhamos dados estritamente necessários, ao amparo de contratos de operação de tratamento, com os seguintes parceiros:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li><strong>Entregador parceiro</strong> (no caso do CLIENTE): nome, telefone, endereços de coleta e entrega, descrição da encomenda — exclusivamente para a execução do PEDIDO.</Li>
          <Li><strong>Mercado Pago</strong> (Mercado Pago Instituição de Pagamento Ltda.): processamento de pagamentos.</Li>
          <Li><strong>Resend</strong> (Resend, Inc., EUA): envio de e-mails transacionais.</Li>
          <Li><strong>Google</strong> (Google Maps Platform): geocodificação e mapas.</Li>
          <Li><strong>Supabase</strong> (Supabase, Inc., EUA): banco de dados e autenticação.</Li>
          <Li><strong>Vercel</strong> (Vercel, Inc., EUA): hospedagem da aplicação web.</Li>
          <Li><strong>Autoridades competentes</strong>: quando exigido por lei, ordem judicial ou requisição administrativa válida.</Li>
        </ol>
        <P>Não vendemos, alugamos ou cedemos dados pessoais a terceiros para fins de marketing.</P>
      </>
    ),
  },
  {
    id: 'transferencia',
    title: '6. Transferência internacional',
    render: () => (
      <>
        <P>Alguns operadores acima estão sediados fora do Brasil (Estados Unidos). Tais transferências são realizadas com fundamento no art. 33, V e IX, da LGPD, mediante cláusulas contratuais padrão e garantias adequadas de proteção. Você pode solicitar mais informações por meio do nosso Encarregado.</P>
      </>
    ),
  },
  {
    id: 'cookies',
    title: '7. Cookies e tecnologias similares',
    render: () => (
      <>
        <P>Utilizamos cookies e tecnologias similares de duas naturezas:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li><strong>Essenciais</strong>: necessários ao funcionamento, autenticação e segurança da PLATAFORMA. Não dependem de consentimento.</Li>
          <Li><strong>Opcionais</strong>: estatísticas de uso e melhoria de produto. Dependem de seu consentimento expresso, manifestado pelo banner exibido na primeira visita.</Li>
        </ol>
        <P>Você pode revisar suas preferências limpando o armazenamento local do navegador. Para mais detalhes técnicos, contate o Encarregado.</P>
      </>
    ),
  },
  {
    id: 'retencao',
    title: '8. Retenção dos dados',
    render: () => (
      <>
        <P>Os prazos de retenção observam:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li><strong>Dados cadastrais e de PEDIDOS</strong>: enquanto a conta estiver ativa e por até 5 anos após o encerramento, em razão das obrigações fiscais (Código Tributário Nacional, art. 195) e do prazo prescricional do art. 27 do CDC.</Li>
          <Li><strong>Dados financeiros (PEDIDOS, repasses, transações)</strong>: por até 5 anos para cumprimento da legislação tributária e prevenção a fraudes.</Li>
          <Li><strong>Dados de localização em tempo real</strong>: armazenamos apenas a última posição informada e a sobrescrevemos a cada atualização; logs históricos, quando existentes, têm retenção máxima de 90 dias.</Li>
          <Li><strong>Logs técnicos, de acesso e de segurança</strong>: 12 meses, em conformidade com o art. 15 do Marco Civil da Internet.</Li>
          <Li><strong>Provas de aceite legal</strong> (Termos, Política de Privacidade, Contrato de Intermediação): mantidas por todo o período de relação contratual e pelos prazos prescricionais aplicáveis.</Li>
          <Li><strong>Dados anonimizados</strong>: poderão ser mantidos indefinidamente para fins estatísticos e de melhoria do serviço, sem que seja possível identificar o titular.</Li>
        </ol>
      </>
    ),
  },
  {
    id: 'direitos',
    title: '9. Direitos do titular',
    render: () => (
      <>
        <P>Nos termos do art. 18 da LGPD, você pode, a qualquer tempo, solicitar:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>confirmação da existência de tratamento;</Li>
          <Li>acesso aos seus dados;</Li>
          <Li>correção de dados incompletos, inexatos ou desatualizados;</Li>
          <Li>anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com a LGPD;</Li>
          <Li>portabilidade a outro fornecedor;</Li>
          <Li>eliminação dos dados tratados com seu consentimento, observadas as ressalvas do art. 16 da LGPD;</Li>
          <Li>informação sobre as entidades públicas e privadas com as quais compartilhamos dados;</Li>
          <Li>informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;</Li>
          <Li>revogação do consentimento.</Li>
        </ol>
        <P>Para exercer qualquer direito, utilize nosso <strong>formulário em fretz.com.br/lgpd</strong> ou envie e-mail a privacidade@fretz.com.br informando o e-mail e o WhatsApp utilizados no cadastro. Responderemos em até <strong>15 (quinze) dias</strong>, podendo solicitar comprovação de identidade para evitar fraudes (art. 18, § 5º, LGPD).</P>
      </>
    ),
  },
  {
    id: 'exclusao',
    title: '10. Como tratamos pedidos de exclusão',
    render: () => (
      <>
        <P>10.1. Em razão de obrigações legais e regulatórias a que estamos submetidos, o pedido de eliminação de dados é executado por meio de <strong>anonimização robusta</strong>, nas seguintes etapas:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>os dados que identificam diretamente o titular (nome, e-mail, WhatsApp, CPF, CNH, fotos, placa) são <strong>substituídos por valores fictícios irreversíveis</strong>;</Li>
          <Li>a conta é desativada e não pode mais ser acessada, contatada ou utilizada para marketing, profiling ou qualquer outra finalidade;</Li>
          <Li>os <strong>registros financeiros, fiscais e operacionais</strong> de PEDIDOS já realizados (valor, data, distância, status) são preservados em forma anonimizada pelo prazo legal, conforme exigido pelo Código Tributário Nacional, pelo Código de Defesa do Consumidor (art. 27) e pelo Marco Civil da Internet (art. 15);</Li>
          <Li>após o decurso dos prazos legais aplicáveis, os registros remanescentes podem ser eliminados, agregados estatisticamente ou mantidos exclusivamente para o exercício regular de direitos em processos judiciais, administrativos ou arbitrais.</Li>
        </ol>
        <P>10.2. A retenção dessas informações tem fundamento exclusivo nas hipóteses do <strong>art. 16, I e IV, da LGPD</strong> (cumprimento de obrigação legal/regulatória e uso exclusivo do controlador, vedado acesso por terceiro). Esses dados <strong>NÃO</strong> são utilizados para qualquer finalidade comercial, publicitária ou de perfilamento.</P>
        <P>10.3. Caso uma autoridade judicial ou administrativa competente determine, no futuro, o fornecimento de dados sobre PEDIDOS já anonimizados, a FRETZ atenderá à requisição estritamente nos limites da ordem.</P>
      </>
    ),
  },
  {
    id: 'anpd',
    title: '11. Reclamação à ANPD',
    render: () => (
      <>
        <P>Adotamos medidas técnicas e administrativas razoáveis para proteger os dados contra acessos não autorizados, perda, destruição ou tratamento ilícito, incluindo:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>criptografia em trânsito (HTTPS/TLS);</Li>
          <Li>controle de acesso baseado em função e princípio do menor privilégio;</Li>
          <Li>autenticação de administradores;</Li>
          <Li>monitoramento, registros de auditoria e <em>rate limiting</em> em endpoints sensíveis;</Li>
          <Li>backups periódicos;</Li>
          <Li>contratos de operação de tratamento com todos os operadores.</Li>
        </ol>
        <P>Apesar dos esforços, nenhum sistema é totalmente imune. Em caso de incidente de segurança que possa acarretar risco ou dano relevante, comunicaremos a ANPD e os titulares afetados, na forma do art. 48 da LGPD.</P>
      </>
    ),
  },
  {
    id: 'criancas',
    title: '12. Crianças e adolescentes',
    render: () => (
      <>
        <P>A PLATAFORMA não é direcionada a menores de 18 anos. Não tratamos conscientemente dados pessoais de crianças e adolescentes. Caso tomemos conhecimento de tratamento dessa natureza, eliminaremos os dados ou solicitaremos o consentimento qualificado dos responsáveis, conforme o art. 14 da LGPD.</P>
      </>
    ),
  },
  {
    id: 'alteracoes',
    title: '13. Alterações desta Política',
    render: () => (
      <>
        <P>Esta Política pode ser atualizada periodicamente. A versão vigente está sempre disponível em fretz.com.br/privacidade, com indicação da data da última atualização. Alterações materiais serão comunicadas pelos canais cadastrados.</P>
      </>
    ),
  },
  {
    id: 'contato',
    title: '14. Contato',
    render: () => (
      <>
        <P>Dúvidas, requisições ou reclamações podem ser dirigidas ao Encarregado:</P>
        <P><strong>privacidade@fretz.com.br</strong></P>
      </>
    ),
  },
];

const Privacidade = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 bg-mesh-light opacity-60" aria-hidden="true" />
        <div className="relative container mx-auto px-4 lg:px-6 py-16 lg:py-24 max-w-3xl">
          <span className="badge-brand mb-5">Documento legal</span>
          <h1 className="font-display text-display-lg text-ink-900">Política de Privacidade</h1>
          <p className="mt-3 text-ink-500">
            Vigente a partir de 01 de maio de 2026 · Versão 2.0
          </p>

          <div className="mt-8 p-5 rounded-2xl bg-brand-50 border border-brand-100">
            <p className="text-sm text-ink-700 leading-relaxed">
              <strong>Resumo</strong>: a FRETZ trata seus dados pessoais para
              executar PEDIDOS e cumprir obrigações legais. Compartilhamos
              apenas o necessário com operadores essenciais (Mercado Pago,
              Google, Supabase, Resend, Vercel). Não vendemos seus dados.
              Você tem direitos garantidos pela LGPD que pode exercer pelo
              e-mail privacidade@fretz.com.br.
            </p>
          </div>

          <div className="mt-10 space-y-10">
            {sections.map((s) => (
              <section key={s.id} id={s.id}>
                <h2 className="font-display text-xl font-bold text-ink-900">{s.title}</h2>
                {s.render()}
              </section>
            ))}
          </div>

          <div className="mt-12 p-6 rounded-2xl bg-ink-50 border border-ink-100">
            <p className="text-sm text-ink-600 leading-relaxed">
              <strong>BUZAYM MARKETING DIGITAL LTDA</strong> · CNPJ 49.130.988/0001-00<br />
              Encarregado: privacidade@fretz.com.br · Geral: contato@fretz.com.br
            </p>
          </div>
        </div>
      </section>

      <Footer />
      <FooterCopyright />
    </div>
  );
};

export default Privacidade;
